/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useIntl } from 'react-intl'
import { NumericFormat } from 'react-number-format'
import { PaymentRequestModel } from '../../models/PaymentRequestModel'
import { AsyncSelect2 } from '../../../_metronic/partials/select/AsyncSelect2'
import { STORES_ENDPOINT } from '../../constants/endpoints'
import { formatPrice, revertPriceNumner } from '../../selectors'
import { getStoreDebt } from './PaymentRequestCRUD'
import { Toast } from '../../modules/common/helper'

type Props = {
    show: boolean
    mode: string
    data?: PaymentRequestModel
    onClose: () => void
    onSubmit: (values: any, actions: any) => void
}
const addSchema = Yup.object().shape({
    store_id: Yup.string().nullable().required('Vui lòng chọn cửa hàng'),
    amount: Yup.number().required('Vui lòng nhập giá trị').min(1, 'Vui lòng nhập số tiền').test('max-amount', 'Số tiền không hợp lệ', function (value) { 
        const { debt } = this.parent; 
        if (value == null) return true; 
        return value <= debt; 
    }),
})

const PaymentRequestModal: React.FC<Props> = ({ show, mode, data, onClose, onSubmit }) => {
    const intl = useIntl();
    const [initValues, setInitValues] = useState<PaymentRequestModel>({})

    useEffect(() => {
        setInitValues({})
    }, [show]) 

    const getDebt = async (storeId: number, values: PaymentRequestModel) => {
        try {
            const { data } = await getStoreDebt(storeId)
            
            let debt = (data?.data?.total_debt ?? 0) - (data?.data?.total_transaction ?? 0)
            setInitValues({
                ...values,
                address: data?.data?.store?.address ?? '',
                debt: debt,
                amount: debt,
                remain_amount: 0
            })
        } catch (err: any) {
            Toast.fire({
                icon: 'warning',
                title: 'Không thể lấy dữ liệu công nợ!'
            })
        }
    }
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Tạo yêu cầu thanh toán</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <Formik enableReinitialize validationSchema={addSchema} initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange, errors }) => (
                        
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Cửa hàng</label>
                                    <AsyncSelect2
                                        sourceUrl={`${STORES_ENDPOINT}`}
                                        defaultOptions
                                        default
                                        name='store_id'
                                        onChange={(selectedOption: any) => {
                                            console.log(selectedOption)
                                            handleChange({target: {name: 'store', value: selectedOption}});
                                            handleChange({target: {name: 'store_id', value: selectedOption.value}});
                                            getDebt(selectedOption.value, {
                                                ...values, 
                                                store: selectedOption,
                                                store_id: selectedOption.value, 
                                                address: selectedOption.address
                                            })
                                        }}
                                    />
                                    <ErrorMessage name='store_id' className='text-danger' component='span' />
                                </div>
                                {values?.store_id && (
                                    <>
                                    {console.log(values)}
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className="form-label">Địa chỉ</label>
                                            <Field
                                                type='text'
                                                className='form-control'
                                                placeholder=''
                                                autoComplete='nope'
                                                name='address'
                                                disabled={true}
                                            />
                                            <div className="fv-plugins-message-container invalid-feedback">
                                                <ErrorMessage name='address' />
                                            </div>
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className="form-label">Công nợ cũ</label>
                                            <Field
                                                type='text'
                                                className='form-control'
                                                placeholder=''
                                                autoComplete='nope'
                                                name='dept'
                                                disabled={true}
                                                value={formatPrice(values?.debt ?? 0)}
                                            />
                                            <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='dept' /></div>
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className="required form-label">Số tiền thu</label>
                                            <NumericFormat
                                                thousandSeparator=","
                                                name='amount'
                                                className='form-control'
                                                required
                                                onBlur={(e) => {
                                                    handleChange({target: {name: 'amount', value: revertPriceNumner(e.target.value)}});
                                                    handleChange({target: {name: 'remain_amount', value: (values.debt ?? 0) - revertPriceNumner(e.target.value)}});
                                                }}
                                                value={values?.amount ?? 0}
                                            />
                                            <ErrorMessage name='amount' className='text-danger' component='span' />
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className="form-label">Công nợ còn lại</label>
                                            <Field
                                                type='text'
                                                className='form-control'
                                                placeholder=''
                                                autoComplete='nope'
                                                value={formatPrice((values.debt ?? 0) - (values.amount ?? 0))}
                                                name='remain_amount'
                                                disabled={true}
                                            />
                                            <ErrorMessage name='new_dept' className='text-danger' component='span' />
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className="form-label">Ghi chú</label>
                                            <Field
                                                as="textarea"
                                                className="form-control"
                                                value={values.note ?? ""}
                                                id="note"
                                                name="note"
                                                rows={3}
                                            />
                                            <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='note' /></div>
                                        </div>
                                    </>
                                )}
                                
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Hủy</button>
                                {values?.store_id && (
                                    <button className="btn btn-bg-success" type="submit">Tạo yêu cầu</button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default PaymentRequestModal
